
import { defineComponent, PropType } from 'vue'

import { Run, RunStatus } from '~/types/types'
import { generalizeRunStatuses } from '~/utils/runs'
import { shortenLargeNumber } from '~/utils/string'
import { runStatusIcon, runStatusIconColor } from '~/utils/ui'

import ZMenu from '../zeal/ZMenu/ZMenu.vue'

export default defineComponent({
  name: 'RunSelector',
  // Imported manually since tests are not able to detect full import path for `trigger` event
  components: { ZMenu },
  methods: {
    runStatusIcon,
    runStatusIconColor,
    shortenLargeNumber,
    isRunPending(status: RunStatus) {
      return status === RunStatus.Pend
    },
    isRunSkipped(status: RunStatus) {
      return generalizeRunStatuses(status).status === RunStatus.Skip
    },
    getMenuItemProps(run: Run) {
      return this.isRunSkipped(run.status)
        ? {
            as: 'div',
            disabled: true
          }
        : { as: 'nuxt-link', to: this.$generateRoute(['run', run.runId]) }
    }
  },
  props: {
    branchRuns: {
      type: Array as PropType<Run[]>,
      required: true
    }
  },
  computed: {
    countText(): string {
      const runCount = this.branchRuns.length
      if (runCount === 1) {
        return `${runCount} more run`
      }
      if (runCount > 1 && runCount <= 30) {
        return `${runCount} more runs`
      }
      return '30 more runs'
    }
  }
})
